import React from 'react';
import {FormattedMessage} from 'react-intl';
import LoadingPlaceholder from '../LoadingPlaceholder/LoadingPlaceholder';

import './FlexibleDatesOptionPropertyCount.less';

const FlexibleDatesOptionPropertyCount = ({
    loading,
    resultCountDifferenceForNewDates
}) => {
    const defaultPropertyPlusLabel =
        '+{propertyCount, plural, zero {{propertyCount} properties} one {{propertyCount} property} few {{propertyCount} properties} many {{propertyCount} properties} other {{propertyCount} properties}}';

    const defaultPropertyMinusLabel =
        '-{propertyCount, plural, one {{propertyCount} property} few {{propertyCount} properties} many {{propertyCount} properties} other {{propertyCount} properties}}';

    const showLoadingState = () => {
        return loading ? (
            <LoadingPlaceholder
                extraClasses="FlexibleDatesOptionPropertyCount--placeHolder"
                rounded
            />
        ) : null;
    };
    return !loading && resultCountDifferenceForNewDates !== null ? (
        <span className="FlexibleDatesOptionPropertyCount">
            <FormattedMessage
                id={
                    resultCountDifferenceForNewDates >= 0
                        ? 'propertiesPlus'
                        : 'propertiesMinus'
                }
                defaultMessage={
                    resultCountDifferenceForNewDates >= 0
                        ? defaultPropertyPlusLabel
                        : defaultPropertyMinusLabel
                }
                values={{
                    propertyCount: Math.abs(resultCountDifferenceForNewDates)
                }}
            />
        </span>
    ) : (
        showLoadingState()
    );
};

export default FlexibleDatesOptionPropertyCount;
